import React, { useEffect, useState } from "react";
import EmailForm from "./components/emailForm/emailForm.tsx";
import styles from "./App.module.scss";
import Experience from "./components/experience/experience.tsx";
import TicTacToe from "./components/ticTacToe/ticTacToe.tsx";
import Header from "./components/header/header.tsx";
import Loader from "./components/loader/loader.tsx";
import Footer from "./components/footer/footer.tsx";
import Intro from "./components/introduction/intro.tsx";
import starsStyles from "./components/introduction/AppStars.module.scss";
import db from "../src/firebase_setup/firebase.js";

function App() {
  const [loading, setLoading] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [rapolasWinsCount, setRapolasWinsCount] = useState(0);
  const [visitorWinsCount, setVisitorWinsCount] = useState(0);
  const [dataReceived, setDataReceived] = useState(false);

  const dataFetch = async () => {
    await db
      .collection("visitorCount")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          const data = doc.data();
          setRapolasWinsCount(data.RapolasWinsCount);
          setVisitorWinsCount(data.visitorWinsCount);
          setDataReceived(true);
        });
        setLoading(false);
        setTimeout(() => {
          setIsLoading(false);
        }, 4000); // wait for the animations to complete (4secs)
      });
    // .catch((error) => console.log(error));
  };

  useEffect(() => {
    setLoading(true);
    setIsLoading(true);
    dataFetch();
  }, []);

  return (
    <>
      {isloading ? (
        <div className={styles.loader}>
          <Loader loading={loading} />
        </div>
      ) : (
        <></>
      )}
      {!loading ? (
        <>
          <header className={styles.header}>
            <Header />
          </header>
          <div id={styles.body}>
            <div className={styles.intro}>
              <div id={starsStyles.stars}></div>
              <div id={starsStyles.stars2}></div>
              <div id={starsStyles.stars3}></div>
              <Intro />
            </div>
            <div className={styles.container}>
              <div className={styles.wrapper}>
                <div className={styles.pageLayout}>
                  <Experience />
                  <TicTacToe
                    rapolasWins={rapolasWinsCount}
                    visitorsWins={visitorWinsCount}
                    dataReceived={dataReceived}
                  />

                  <EmailForm />
                </div>
              </div>
            </div>
          </div>
          <footer>
            <Footer />
          </footer>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

export default App;
